var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center gap-2"},[_c('p',[_vm._v("Hora")]),_c('div',{staticClass:"bg-ontick-steel-500 custom-shadow flex h-[24px] items-center gap-0.5 rounded"},[_c('input',{attrs:{"type":"number","step":1,"min":0,"max":23,"placeholder":"00"},domProps:{"value":_vm.value.hour},on:{"blur":function($event){_vm.$emit('input', {
          ..._vm.value,
          hour: _vm.normalize($event.target.value, 'hour'),
        })}}}),_c('span',[_vm._v(":")]),_c('input',{attrs:{"type":"number","step":1,"min":0,"max":59,"placeholder":"00"},domProps:{"value":_vm.value.minute},on:{"blur":function($event){_vm.$emit('input', {
          ..._vm.value,
          minute: _vm.normalize($event.target.value, 'minute'),
        })}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }